<mat-dialog-content class="confirmation">
  <div class="mat-dialog-body">
    <!-- <mat-progress-bar mode="indeterminate"></mat-progress-bar> -->
    <div class="d-flex justify-content-center">
      <ng-lottie width="250px" height="250px" [options]="options"></ng-lottie>
    </div>
    <h4 class="label-form text-center bold">
      {{"courses.plagiarismCheck"|translate}}
    </h4>
    <p class="label-helper text-center mb-3">
      {{data.paraphra}}
    </p>
    <p class="label-helper text-center mb-3">
      <span class="badge_status_progress warning">
        {{"courses.pleaseWaitUntilComplete"|translate}}
      </span>
    </p>
    <!-- <div class="d-flex align-items-center justify-content-center mt-2">
      <button class="mr-2" mat-raised-button color="grey" mat-dialog-close>Cancel</button>
    </div> -->
  </div>
</mat-dialog-content>
